import useApi, { ApiOptions } from '../base/useApi';
import { CardModificationDTO } from '@src/adapters/dto/card/CardModificationDTO';
import CardItemDTO from '@src/adapters/dto/card/CardItemDTO';

interface Params {
  cardId: string;
  inventoryId: string;
}

interface Result {
  cardItem: CardItemDTO;
  modification: CardModificationDTO;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/card/create_item_with_inventory',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useCreateCardItemWithInventoryLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useCreateCardItemWithInventoryLazy;
